const DATE_FORMAT = 'DD-MM-YYYY';

export function formatDate(date) {
  return moment(date).format(DATE_FORMAT);
}

export default formatDate
